import { call, put } from 'redux-saga/effects';
import { api } from 'rp-auth';
import {
  loadUserInfoRequest,
  loadUserInfoSuccess,
  loadUserInfoFailure,
} from '../actions/userInfo';

const { getUserInfo, getUserCardInfo } = api;

export default function* (accountReference, session) {
  try {
    if (!session) {
      return null;
    }

    yield put(loadUserInfoRequest());

    const userInfo = yield call(getUserInfo, accountReference, session);
    const cardInfo = yield call(getUserCardInfo, accountReference, session);

    yield put(loadUserInfoSuccess({
      ...userInfo,
      CreditCard: cardInfo.cards.sort((prevCard, nextCard) =>
        (new Date(nextCard.creationDate) - new Date(prevCard.creationDate)))[0],
    }));

    return userInfo;
  } catch (error) {
    yield put(loadUserInfoFailure(error));
    return null;
  }
}
